// extracted by mini-css-extract-plugin
module.exports = {"focused":"_2Y0Ez","root":"_3k95X","container":"_249eT","expanded":"_39ReI"};